import { render, staticRenderFns } from "./groupMaker.vue?vue&type=template&id=d66846f8"
import script from "./groupMaker.vue?vue&type=script&lang=js"
export * from "./groupMaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports